/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-expressions */
import React, { Fragment, useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import dayjs from 'dayjs';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Tooltip, Spin, DatePicker, Button, Popover,
  notification,
} from 'antd';
import './style.scss';
import H3Text from '@Uilib/h3Text';
import SelectDepartment from '@Components/Common/SelectDepartment';
import { toISTDate, QUANTITY } from '@Apis/constants';
import TagSelector from '@Components/Common/Selector/TagSelector';
import PurchaseOrderActions from '@Actions/purchaseOrderActions';
import H3Progress from '@Components/Common/H3Progress';
import H3Image from '@Uilib/h3Image';
import MrpV2Actions from '@Actions/production/mrpV2Actions';
import H3DateSelector from '@Uilib/h3DateSelector';
import searchIcon from '@Images/icons/icon-search.png';
import H3FormInput from '@Uilib/h3FormInput';
import HideValue from '../../../../../Common/RestrictedAccess/HideValue';

const LinkExistingPoToMrp = ({
  user, mrpId, getMOLoading, callback, MONEY, mrpData, getLinkExistingPoToMrpLoading, ignoreStockItemsAvailableStock, LinkExistingPoToMrpV2Loading,
  LinkExistingPoToMrpV2, linkPoToMrpLoading, productSkuIds, getLinkExistingPoToMrp, selectedProductLines, ignoreStockItemsSafetyStock, priceMasking,
}) => {
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [estimatedDeliveryDate, setEstimatedDeliveryDate] = useState('');
  const [selectedTag, setSelectedTag] = useState([]);
  const [startDateMomentEpoch, setStartDateMomentEpoch] = useState('');
  const [endDateMomentEpoch, setEndDateMomentEpoch] = useState('');
  const [keyword, setKeyword] = useState('');
  const [disabledDepartmentSelection, setDisabledDepartmentSelection] = useState(false);
  const [linkedPoToProductData, setLinkedPoToProductData] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const calculateLinkedQuantities = (poLines, pendingQuantity) => {
    let remainingPendingQuantity = pendingQuantity;

    return poLines?.map((poLine) => {
      const linkedQuantity = Math.min(poLine.available_quantity, remainingPendingQuantity);
      remainingPendingQuantity -= linkedQuantity;

      return {
        ...poLine,
        linked_quantity: linkedQuantity,
      };
    });
  };

  useEffect(() => {
    if (mrpData?.departments) {
      setSelectedDepartment(mrpData?.departments?.map((department) => department?.department_id));
      setDisabledDepartmentSelection(true);
    } else {
      setSelectedDepartment([]);
      setDisabledDepartmentSelection(false);
    }
  }, [mrpData]);
  useEffect(() => {
    if (mrpData?.departments) {
      setSelectedDepartment(mrpData?.departments?.map((department) => department?.department_id));
      setDisabledDepartmentSelection(true);
    } else {
      setSelectedDepartment([]);
      setDisabledDepartmentSelection(false);
    }
    const payload = {
      tenantId: mrpData?.tenant_id,
      searchKeyword: keyword || null,
      fromDate: startDateMomentEpoch || null,
      toDate: endDateMomentEpoch || null,
      edd: estimatedDeliveryDate ? dayjs(estimatedDeliveryDate).format('YYYY-MM-DD') : null,
      productSkuIds: productSkuIds?.length ? productSkuIds?.join(',') : null,
      tags: selectedTag?.length ? selectedTag?.join(',') : null,
      departmentIds: selectedDepartment?.length ? selectedDepartment.join(',') : null,
    };
    getLinkExistingPoToMrp(payload, (PoDataProductWise) => {
      const newPOData = PoDataProductWise?.map((po) => {
        // to get the product data from selectedProductLines
        const selectedProductLine = selectedProductLines?.find((productLine) => productLine?.product_sku_id === po?.product_sku_id);

        // how much quantity is pending for this product
        const pendingQuantity = selectedProductLine?.pending_quantity || 0;

        // total available quantity of all the po lines linked to this product
        const totalAvailableQuantity = po?.po_lines?.reduce((total, poLine) => total + poLine?.available_quantity, 0);

        // adjust the pending quantity based on the available quantity of all the po lines linked to this product
        const adjustedPendingQuantity = Math.min(pendingQuantity, totalAvailableQuantity);

        return {
          po_lines: calculateLinkedQuantities(po.po_lines, adjustedPendingQuantity),
          ...selectedProductLine || {},
          to_be_ordered: pendingQuantity,
          pending_quantity: adjustedPendingQuantity,
        };
      });

      setLinkedPoToProductData(newPOData);
    });
  }, [mrpData]);

  const handleSearchPo = () => {
    // tenant_id ,search_keyword,from_date,to_date,edd,product_sku_ids,tags,department_ids
    const payload = {
      tenantId: mrpData?.tenant_id,
      searchKeyword: keyword || null,
      fromDate: startDateMomentEpoch || null,
      toDate: endDateMomentEpoch || null,
      edd: estimatedDeliveryDate ? dayjs(estimatedDeliveryDate).format('YYYY-MM-DD') : null,
      productSkuIds: productSkuIds?.length ? productSkuIds?.join(',') : null,
      tags: selectedTag?.length ? selectedTag?.join(',') : null,
      departmentIds: selectedDepartment?.length ? selectedDepartment.join(',') : null,
    };
    getLinkExistingPoToMrp(payload, (PoDataProductWise) => {
      const newPOData = PoDataProductWise?.map((po) => {
        const selectedProductLine = selectedProductLines?.find((productLine) => productLine?.product_sku_id === po?.product_sku_id);
        return {
          ...po,
          ...selectedProductLine || {},
        };
      });
      setLinkedPoToProductData(newPOData);
      // callback();
    });
  };

  // function to handle error based on quantity is greater than available or ordered quantity
  const handleErrorForProductLines = (lineData) => {
    if (lineData?.pending_quantity <= 0) {
      return 'Quantity should be greater than 0';
    } if (lineData?.pending_quantity > lineData?.shortage_quantity) {
      return 'Quantity should be less than or equal to Shortage Quantity';
    }
    return '';
  };

  // function to update pending quantity of product and linked quantities of po lines based on new pending quantity
  const updatePendingQuantity = (productSkuId, newPendingQuantity) => {
    const copyData = JSON.parse(JSON.stringify(linkedPoToProductData));

    copyData?.forEach((item) => {
      if (item?.product_sku_id === productSkuId) {
        item.pending_quantity = newPendingQuantity;
        item.po_lines = calculateLinkedQuantities(item?.po_lines, newPendingQuantity);
      }
    });

    setLinkedPoToProductData(copyData);
  };

  // function to update product linked quantities based on new po line linked quantity
  const updateLinkedQuantity = (productSkuId, poLineId, newLinkedQuantity) => {
    const copyData = JSON.parse(JSON.stringify(linkedPoToProductData));

    copyData?.forEach((item) => {
      if (item.product_sku_id === productSkuId) {
        // Update the linked quantity for the specific po_line
        item?.po_lines?.forEach((poLine) => {
          if (poLine?.po_line_id === poLineId) {
            poLine.linked_quantity = Number(newLinkedQuantity);
          }
        });

        // Recalculate the pending quantity based on the sum of linked quantities of all po_lines
        const totalLinkedQuantity = item?.po_lines?.reduce((total, poLine) => total + poLine.linked_quantity, 0);
        // item.pending_quantity = Math.min(item.to_be_ordered, totalLinkedQuantity);
        item.pending_quantity = totalLinkedQuantity;
      }
    });
    setLinkedPoToProductData(copyData);
  };
  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  // column to show product links Pos
  const getPoColumns = () => {
    const poListColumns = [
      {
        title: 'Purchase Order#',
        dataIndex: 'po_number',
        render: (text, record) => (
          <div
            className="list__actions"
            style={{
              color: '#2D7DF7', fontWeight: '600', fontSize: '12px',
            }}
          >
            {record?.po_number}
          </div>
        ),
        fixed: 'left',
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Vendor',
        render: (text, record) => (
          <Fragment>
            <div
              style={{
                color: 'rgb(106, 106, 106)',
                fontWeight: '600',
                fontSize: '12px',
                cursor: 'pointer',
              }}
            />
            <div
              style={{
                color: '#2D7DF7', fontWeight: '600', fontSize: '12px', cursor: 'pointer',
              }}
              onClick={() => window.open(`/vendors/view/${record?.seller_info?.seller_id}`)}
            >
              {(record && record.seller_info) ? `${record?.seller_info?.internal_slr_code ? `${record?.seller_info?.internal_slr_code} - ` : ''}${record.seller_info?.seller_name}`?.trim() : ''}
            </div>
            <div>
              {record?.seller_address?.city ? record.seller_address.city : ''}
            </div>
          </Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Delivery Date',
        render: (text, record) => (
          <div>
            {toISTDate(record?.edd).format('DD/MM/YYYY')}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Offer Price',
        render: (text, record) => ((isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view offer price"} /> : (
          `${MONEY((record.offer_price || '0'), record?.org_currency_info?.currency_code)} / (${record?.purchase_uom_info?.[0]?.uqc || ''})`
        )),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Purchased Quantity',
        render: (text, record) => (
          <div>{`${QUANTITY(record?.quantity || 0, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase() || ''}`}</div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Purchased Quantity',
        render: (text, record) => (
          <div>{`${QUANTITY(record?.quantity || 0, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase() || ''}`}</div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Available Quantity',
        render: (text, record) => (
          <div>{`${QUANTITY(record?.available_quantity || 0, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase() || ''}`}</div>

        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Quantity to link',
        render: (record) => {
          const errorCondition = Number(record?.linked_quantity) > Number(record?.available_quantity);
          return (
            <div style={{ width: '80px' }}>
              <H3FormInput
                value={record?.linked_quantity}
                type="number"
                inputClassName={`orgFormInput ${errorCondition ? 'orgFormInputError' : ''} `}
                // onChange={(e) => {
                //   const copyData = JSON.parse(JSON.stringify(linkedPoToProductData));
                //   copyData.map((item) => {
                //     if (record.product_sku_id === item.product_sku_id) {
                //       item.po_lines.map((poLine) => {
                //         if (poLine.po_line_id === record.po_line_id) {
                //           poLine.linked_quantity = e.target.value;
                //         }
                //         return linkedPoToProductData;
                //       });
                //     }
                //     return linkedPoToProductData;
                //   });
                //   setLinkedPoToProductData(copyData);
                // }}
                onChange={(e) => {
                  const newLinkedQuantity = Number(e.target.value);
                  updateLinkedQuantity(record.product_sku_id, record.po_line_id, newLinkedQuantity);
                }}
              />
              {errorCondition && (
                <div style={{
                  color: 'red',
                  fontSize: '11px',
                  marginTop: '2px',
                }}
                >
                  Quantity should be less than or equal to Available Quantity
                </div>
              )}
            </div>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: '',
        key: 'action',
        render: (text, record) => (
          <div className="list__actions">
            <div
              className="list__actions-button list__actions-button-dark"
              style={{ width: '60px', whiteSpace: 'nowrap' }}
              onClick={() => {
                window.open(`/approval?type=po&id=${record.po_id}`, '_blank');
              }}
            >
              View
            </div>
          </div>
        ),
        fixed: 'right',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        className: 'list__actions-column',
      },
    ];
    return poListColumns;
  };

  // columns to show product info
  const getProductLinkedPoColumns = () => {
    const mrpColumns = [
      {
        title: 'SKU#',
        fixed: 'left',
        width: '180px',
        render: (record) => (
          <Fragment>
            <Tooltip title={`${record?.internal_sku_code || ''} - ${record?.product_sku_name}`}>
              {record?.product_sku_name ? (
                <div className="material-shortage-sku-name">
                  <Link to={`/inventory/product/view/${record?.product_sku_id}`} target="_blank">
                    {`#${record?.internal_sku_code}`}
                  </Link>
                  <span>
                    {` - ${record?.ref_product_code ? `${record?.ref_product_code} - ` : ''}${record?.product_sku_name}`}
                  </span>
                </div>
              ) : '-'}
            </Tooltip>
          </Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Ordered',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>{`${QUANTITY(record?.demand_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Fulfilled',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>{`${QUANTITY((record?.issued_quantity ? record?.issued_quantity : record?.invoiced_quantity) || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Reserved',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (
              <Fragment>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div>
                    {`${QUANTITY((record?.reserved_quantity), record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
                  </div>
                </div>
                <div style={{
                  paddingRight: '5px', width: '80px', cursor: 'pointer',
                }}
                >
                  <Popover
                    title={(
                      <div>
                        <H3Text text={`${record?.demand_quantity} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`} />
                        <H3Text text={`${record?.reserved_quantity} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`} />
                      </div>
                    )}
                    zIndexPopup={99999}
                  >
                    <H3Progress percent={Math.round(parseInt((record?.reserved_quantity / record?.demand_quantity) * 100))} barWidth="150px" />
                  </Popover>
                </div>
              </Fragment>
            ) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Purchased',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (<div>{`${QUANTITY(record?.purchase_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Safety Stock',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (
              <div className={ignoreStockItemsSafetyStock ? 'strike-text' : ''}>
                {`${QUANTITY(record?.threshold_qty || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
              </div>
            ) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Required',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (<div>{`${QUANTITY(record?.shortage_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Available',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (
              <div className={ignoreStockItemsAvailableStock ? 'strike-text' : ''}>
                {`${QUANTITY(record?.available_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
              </div>
            ) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Shortage',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (
              <div>
                {`${QUANTITY(record?.to_be_ordered || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
              </div>
            ) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Quantity to link',
        width: '110px',
        fixed: 'right',
        render: (record) => {
          const errorCondition = handleErrorForProductLines(record);
          return (
            <div style={{ width: '80px' }}>
              <H3FormInput
                value={record?.pending_quantity}
                type="number"
                inputClassName={`orgFormInput ${errorCondition ? 'orgFormInputError' : ''} `}
                // onChange={(e) => {
                //   const copyData = JSON.parse(JSON.stringify(linkedPoToProductData));
                //   copyData.map((item) => {
                //     if (record.key === item.product_sku_id) {
                //       item.pending_quantity = e.target.value;
                //     }
                //     return linkedPoToProductData;
                //   });
                //   setLinkedPoToProductData(copyData);
                // }}
                onChange={(e) => {
                  const newPendingQuantity = Number(e.target.value);
                  updatePendingQuantity(record.key, newPendingQuantity);
                }}
              />
              {errorCondition && (
                <div
                  style={{
                    color: 'red',
                    fontSize: '11px',
                    marginTop: '2px',
                  }}
                >
                  {errorCondition}
                </div>
              )}
            </div>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
    ];

    return mrpColumns;
  };

  const validatePoLines = (poData) => {
    for (const item of poData) {
      const totalLinkedQuantity = item.po_lines.reduce((total, poLine) => total + Number(poLine.linked_quantity || 0), 0);

      if (totalLinkedQuantity > item.to_be_ordered) {
        notification.error({
          message: `Total linked quantity for product ${item.product_sku_name} exceeds the shortage quantity.`,
          placement: 'top',
          duration: 5,
        });
        return false;
      }

      for (const poLine of item.po_lines) {
        if (Number(poLine.linked_quantity) > Number(poLine.available_quantity)) {
          notification.error({
            message: `Linked quantity for PO line ${poLine.po_number} exceeds the available quantity.`,
            placement: 'top',
            duration: 5,
          });
          return false;
        }
      }
    }

    return true;
  };

  const handleSubmission = () => {
    setFormSubmitted(true);

    if (!validatePoLines(linkedPoToProductData)) {
      return;
    }
    const poLines = [];
    linkedPoToProductData?.forEach((item) => {
      item.po_lines?.forEach((poLine) => {
        if (poLine.linked_quantity) {
          poLines.push({
            po_line_id: poLine.po_line_id,
            quantity: Number(poLine.linked_quantity),
            po_id: poLine.po_id,
          });
        }
      });
    });
    if(poLines.length==0){
      return;
    }

    LinkExistingPoToMrpV2({
      po_lines: poLines,
      mrp_id: mrpId,
    }, () => {
      callback();
    });
  };

  return (
    <Spin spinning={getMOLoading === true}>
      <div
        className="link-po-mrp__wrapper"
      >
        <div className="link-po-mrp__filter-wrapper">
          <div className="ant-row">

            <div className="ant-col-md-8">
              <div className="orgInputContainer product-form__right-input">
                <label className="orgFormLabel">
                  Search
                </label>
                <div className="section-search">
                  <div className="section-search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for Purchase Order..."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setKeyword(e.target.value);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setKeyword(keyword);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ant-col-md-8">
              <div className="orgInputContainer product-form__right-input">
                <label className="orgFormLabel">
                  Department
                </label>
                <SelectDepartment
                  title="Select Department"
                  hideTitle
                  selectedDepartment={selectedDepartment}
                  noDropdownAlign
                  onChange={(value) => {
                    setSelectedDepartment(value);
                  }}
                  isMultiple
                  customStyle={{
                    borderRadius: '4px',
                    width: '100%',
                    fontSize: '13px',
                    border: '1px solid rgba(68, 130, 218, 0.2)',
                  }}
                  disabled={disabledDepartmentSelection}
                />
              </div>
            </div>
            <div className="ant-col-md-8">
              <div className="orgInputContainer product-form__right-input">
                <label className="orgFormLabel">
                  Estimated Delivery Date
                </label>
                <DatePicker
                  value={estimatedDeliveryDate}
                  onChange={(value) => {
                    setEstimatedDeliveryDate(value);
                  }}
                  style={{
                    width: '100%',
                    borderRadius: '2px',
                    border: '1px solid rgba(68, 130, 218, 0.2)',
                  }}
                />
              </div>
            </div>
            <div className="ant-col-md-8">
              <div className="orgInputContainer product-form__right-input">
                <label className="orgFormLabel">
                  Select Labels
                </label>
                <TagSelector
                  filter
                  entityType="PURCHASE_ORDER"
                  selectedTags={selectedTag}
                  showSearch
                  showAll={false}
                  noDropdownAlign
                  isMultiple
                  onChange={(value) => {
                    setSelectedTag(value);
                  }}
                  placeholder="Select Label"
                  hideTitle
                />
              </div>
            </div>
            <div className="ant-col-md-8">
              <div className="orgInputContainer product-form__right-input">
                <label className="orgFormLabel">
                  Date
                </label>
                <H3DateSelector
                  customStyle={{
                    borderRadius: '3px', width: '100%', marginTop: '-7px', height: '32px',
                  }}
                  startDate={startDateMomentEpoch}
                  endDate={endDateMomentEpoch}
                  onDateChange={(date) => {
                    if (date?.length === 2) {
                      setStartDateMomentEpoch(dayjs(date[0])?.startOf('day').valueOf());
                      setEndDateMomentEpoch(dayjs(date[1])?.endOf('day').valueOf());
                    } else {
                      setStartDateMomentEpoch(null);
                      setEndDateMomentEpoch(null);
                    }
                  }}
                />
              </div>
            </div>

          </div>
        </div>
        <Button
          type="primary"
          ghost
          onClick={() => {
            handleSearchPo();
          }}
        >
          Search
        </Button>
        <div className="link-po-mrp__table-wrapper">
          <Table
            title={() => (
              <div className="link-po-mrp__table-title">
                <H3Text text={`${linkedPoToProductData?.length || 0} Product'(s)`} className="" />
              </div>
            )}
            bordered
            showHeader
            size="small"
            loading={getLinkExistingPoToMrpLoading || linkPoToMrpLoading}
            columns={getProductLinkedPoColumns()}
            dataSource={linkedPoToProductData?.map((item) => ({
              ...item,
              key: item?.product_sku_id,
            }))}
            scroll={{ x: 'max-content' }}
            pagination={false}
            expandable={{
              expandedRowRender: (record) => (
                <Fragment>
                  <Table
                    showHeader
                    bordered
                    size="small"
                    scroll={{ x: 'max-content' }}
                    columns={getPoColumns()}
                    dataSource={record?.po_lines ? record?.po_lines?.map((item) => ({
                      ...item,
                      key: item?.po_line_id,
                      pending_quantity: linkedPoToProductData?.find((product) => product.product_sku_id === record.product_sku_id)?.pending_quantity,
                    })) : []}
                    pagination={false}
                  />
                </Fragment>
              ),
            }}
          />
        </div>
      </div>
      <div className="custom-drawer__footer" style={{ width: '100%' }}>
        <div className="ant-col-md-6">
          <Button
            type="primary"
            onClick={() => handleSubmission()}
            loading={LinkExistingPoToMrpV2Loading}
            disabled={LinkExistingPoToMrpV2Loading}
          >
            Link Purchase Orders
          </Button>
        </div>
      </div>
    </Spin>
  );
};
const mapStateToProps = ({
  UserReducers, DepartmentReducers, PurchaseOrderReducers, MrpV2Reducers,
}) => ({
  user: UserReducers.user,
  departments: DepartmentReducers.departments,
  getPurchaseOrderByIdLoading: PurchaseOrderReducers.getPurchaseOrderByIdLoading,
  linkPoToMrpLoading: MrpV2Reducers.linkPoToMrpLoading,
  MONEY: UserReducers.MONEY,
  getLinkExistingPoToMrpLoading: MrpV2Reducers.getLinkExistingPoToMrpLoading,
  getLinkPoToMrp: MrpV2Reducers.getLinkPoToMrp,
  LinkExistingPoToMrpV2Loading: MrpV2Reducers.LinkExistingPoToMrpV2Loading,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  getPurchaseOrdersSuccess: (purchaseOrders) => dispatch(PurchaseOrderActions.getPurchaseOrdersSuccess(purchaseOrders)),
  LinkExistingPoToMrpV2: (payload, callback) => dispatch(MrpV2Actions.LinkExistingPoToMrpV2(payload, callback)),
  getLinkExistingPoToMrp: (payload, callback) => dispatch(MrpV2Actions.getLinkExistingPoToMrp(payload, callback)),
  getPurchaseOrderById: (poId, tenantId, callback) => dispatch(PurchaseOrderActions.getPurchaseOrderById(poId, tenantId, callback)),
});

LinkExistingPoToMrp.propTypes = {
  user: PropTypes.any,
  mrpId: PropTypes.any,
  callback: PropTypes.func,
  getMOLoading: PropTypes.bool,
  MONEY: PropTypes.func,
  mrpData: PropTypes.any,
  LinkExistingPoToMrpV2: PropTypes.func,
  linkPoToMrpLoading: PropTypes.bool,
  productSkuIds: PropTypes.any,
  getLinkExistingPoToMrp: PropTypes.func,
  selectedProductLines: PropTypes.any,
  ignoreStockItemsAvailableStock: PropTypes.bool,
  ignoreStockItemsSafetyStock: PropTypes.bool,
  LinkExistingPoToMrpV2Loading: PropTypes.bool,
  getLinkExistingPoToMrpLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LinkExistingPoToMrp));
